import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import ProductCart from "./ProductCart";
import { CustomerSearchBar } from "./CustomerSearchBar";
import { useTotalAmount } from "../TotalAmountContext";
import { useItemCount } from "../ItemCountContext";
import PaymentModal from "../../Modal/Payment_Modal";
import {
  cash_in_session,
  cash_out_session,
  clear_cart_icon,
  customers_icon,
  logo,
  my_ginne_logo,
  return_icon,
} from "../../../assets";
import AddCustomer_Modal from "../../Modal/AddCustomer_Modal";
import { useSelector } from "react-redux";
import axiosInstance from "../../../AxiosInstance";
import { URLS } from "../../../API/API endpoints";
import { useNavigate } from "react-router-dom";
import {
  addProducts,
  clearProducts,
} from "../../../Redux/Action/productsAction";
import { useDispatch } from "react-redux";
import {
  clearCustomer,
  setCustomer,
} from "../../../Redux/Action/getcustomerAction";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import SessionFooter from "../sessioncomponents/SessionFooter";
import { clearReturnProducts } from "../../../Redux/Action/returnproductAction";
import PasswordModal from "../../Modal/Password_Modal";
import { toast } from "react-toastify";
import { verifyPassword } from "../../../API/API Functions/ProductRequest_API";
import { detectWebDeviceType } from "../../../utils";

const LoadingSpinner = () => {
  return (
    <div
      style={{ zIndex: 100 }}
      className="fixed top-0 left-0 w-full h-full z-50 flex justify-center items-center bg-black bg-opacity-50 backdrop-blur"
    >
      <div className="spinner">
        <span className="me-2.5 "></span>
        <span className="me-2.5 "></span>
        <span className="me-2.5 "></span>
      </div>
    </div>
  );
};

export const ProductBox = ({
  products,
  onRemoveProduct,
  onUpdateQuantity,
  onUpdateDiscount,
  userSelectedIndex,
  setUserSelectedIndex,
  isScannerActive,
  returnProducts,
  onClearCart,
  draftOrder,
  addGroupProductModal,
  groupModal,
  isSelect,
}) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setItemCount } = useItemCount();
  const { setTotalAmount } = useTotalAmount();
  const [localProducts, setLocalProducts] = useState([products]);
  const [modals, setModals] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [userSelectedIndex, setUserSelectedIndex] = useState(null);

  const [selectedCustomerS, setSelectedCustomer] = useState({});
  // const localProducts = useSelector((state) => state.products.products);
  const { selectedCustomer } = useSelector((state) => state.getcustomer);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const productRefs = useRef([]);
  const [openPassword, setOpenPassword] = useState(false);
  // const requiredPass = useSelector(
  //   (state) => state?.login?.user?.result?.is_password_restrict
  // );
  const requiredPass = useSelector(
    (state) => state?.permissionReducer?.permissions?.is_password_restrict
  );
  const userData = useSelector((state) => state?.login?.user?.result);
  const groupModalOpen = useSelector(
    (state) => state?.groupModalOpen?.groupModalOpen
  );

  const paymentModalOpen = useSelector(
    (state) => state?.paymentModalOpen?.paymentModalOpen
  );
  const isETAenabled = useSelector(
    (state) => state?.permissionReducer?.permissions?.is_eta_enabled
  );
  const closePasswordModal = () => setOpenPassword(false);

  const [totalBillAmount, setTotalBillAmount] = useState(0);

  // console.log(" GROUP MODAL  BOX", groupModal);
  // console.log(" ADD OUP MODAL  BOX", addGroupProductModal);
  useEffect(() => {
    const productArray = Object.values(products);
    const returnArray = Object.values(returnProducts || []).map((product) => ({
      ...product,
      isReturn: true,
    }));

    setLocalProducts([...productArray, ...returnArray]);
  }, [products, returnProducts]);

  // useEffect(() => {
  //   setItemCount(localProducts?.length);

  //   let total = 0;
  //   localProducts?.forEach((product) => {
  //     const productTotal =
  //       parseFloat(product.sale_price || product.rate) * product.quantity;
  //     total += product.isReturn ? -productTotal : productTotal;
  //   });
  //   setTotalBillAmount(total);
  // }, [localProducts, setItemCount, setTotalAmount]);

  useEffect(() => {
    setItemCount(localProducts?.length);

    let total = 0;
    localProducts?.forEach((product) => {
      const productTax = product?.vat_details;
  const totalProductTax = (product?.sale_price * productTax?.tax_rate_percent)/100;
      const price = product.discount_type && product.discount_type !== "" && !product?.isReturn
        ? (product.price_after_discount || 0)
        : parseFloat((product.sale_price + (productTax?.tax_id && productTax?.is_tax_price_inclusive == false && isETAenabled ? totalProductTax : 0)) || product.rate);

      const productTotal = price * product.quantity;
      total += product.isReturn ? -productTotal : productTotal;
    });

    let totalBill = 0;
    localProducts?.forEach((product) => {
      const productTotal =
        parseFloat(product.sale_price || product.rate) * product.quantity;
      totalBill += product.isReturn ? -productTotal : productTotal;
    });

    setTotalBillAmount(totalBill);

    setTotalAmount(total);
  }, [localProducts, setItemCount, setTotalAmount]);

  useEffect(() => {
    if (products?.length === 0 && returnProducts?.length === 0) {
      setLocalProducts([]);
    }
  }, [products, returnProducts]);

  const handleClearCart = () => {
    dispatch(clearProducts());
    dispatch(clearReturnProducts());
    dispatch(clearCustomer());
    setItemCount(0);
    setTotalAmount(0);
    setLocalProducts([]);
    setSelectedIndex(null);
    // navigate("/session");
  };

  const handleClearCartClick = () => {
    if (requiredPass === true) {
      setOpenPassword(true);
    } else {
      handleClearCart();
    }
  };

  useEffect(() => {
    if (paymentModalOpen) {
      setUserSelectedIndex(null);
    }
  }, [userSelectedIndex, paymentModalOpen]);

  const handlePasswordConfirm = async (enteredPassword) => {
    setLoading(true);
    const userId = userData?.user_id;
    const action = "Clear Cart";
    try {
      const verificationResult = await verifyPassword(
        userId,
        enteredPassword,
        action
      );

      if (
        verificationResult &&
        verificationResult?.result?.status_code === 200
      ) {
        handleClearCart();
        closePasswordModal();
        setLoading(false);
      } else if (verificationResult?.result?.status_code === 400) {
        setLoading(false);
        toast.error(t("Incorrect password"));
        return;
      }
    } catch (error) {
      console.error("Error verifying password:", error);
    }
  };

  const removeCustomer = () => {
    dispatch(clearCustomer());
  };

  const handleKeyDown = (e) => {
    const key = e.key.toLowerCase();
    const normalizedKey =
      {
        ـ: "j",
        "،": "k",
        "ٍ": "s",
        آ: "n",
        "ِ": "a",
        "/": "l",
        "'": "m",
      }[key] || key;

    if (!modals) {
      if (PaymentModal === true) {
        setSelectedIndex(null);
        return;
      }
      if (normalizedKey === "arrowdown") {
        e.preventDefault();
        if (e.shiftKey) {
          setUserSelectedIndex(localProducts.length - 1);
        } else {
          e.preventDefault();
          setUserSelectedIndex((prev) =>
            Math.min(prev + 1, localProducts.length - 1)
          );
        }
      } else if (normalizedKey === "arrowup") {
        e.preventDefault();
        setUserSelectedIndex((prev) => Math.max(prev - 1, 0));
      } else if (normalizedKey === "delete") {
  e.preventDefault();
  if (localProducts[userSelectedIndex]) {
    onRemoveProduct(localProducts[userSelectedIndex]);

    setUserSelectedIndex((prev) =>
      prev > 0 ? prev - 1 : 0
    );
  }
} else if (e.shiftKey && normalizedKey === "backspace") {
        handleClearCartClick();
      }
    }
  };

  useLayoutEffect(() => {
    if (
      userSelectedIndex !== null &&
      productRefs.current[userSelectedIndex] &&
      isSelect
    ) {
      productRefs.current[userSelectedIndex].scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });
    }
  }, [userSelectedIndex, localProducts]);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [
    localProducts,
    selectedIndex,
    modals,
    userSelectedIndex,
    setUserSelectedIndex,
  ]);

  // useEffect(() => {
  //   if (productRefs.current[userSelectedIndex]) {
  //     productRefs.current[userSelectedIndex].scrollIntoView({
  //       behavior: "smooth",
  //       block: "nearest",
  //     });
  //     const scrollToSelectedProduct = () => {
  //       productRefs.current[userSelectedIndex].scrollIntoView({
  //         behavior: "smooth",
  //         block: "center",
  //         inline: "nearest",
  //       });
  //     };

  //     requestAnimationFrame(scrollToSelectedProduct);
  //   }
  // }, [userSelectedIndex]);
const deviceType = detectWebDeviceType();
  return (
    <>
      {loading && <LoadingSpinner />}
      {openPassword === true && (
        <PasswordModal
          onCancel={closePasswordModal}
          onConfirm={handlePasswordConfirm}
          // onCancel={setOpenPassword(false)}
        />
      )}
      <div
        className={`flex ms-4 flex-col w-[100%] ${
          deviceType == "tablet"
            ? "h-[calc(130vh-4rem)]"
            : "h-[calc(138vh-4rem)]"
        }`}
      >
        <CustomerSearchBar removeCustomer={removeCustomer} />
        <div className="flex flex-col text-sm mt-2 mb-2 tracking-wide text-black whitespace-nowrap bg-white rounded-lg border border-solid border-stone-300 w-full h-full overflow-hidden">
          <header className="flex justify-between px-4 py-2 text-base font-semibold tracking-wide bg-[#FCC71D] text-zinc-800">
            <div>{t("Product")}</div>
            <div className="flex items-center justify-center">
              <div className="flex mx-12">{t("Qty")}</div>
              <div className="flex me-7 ">{t("Total")}</div>
              <img
                src={clear_cart_icon}
                alt="clear_cart_icon"
                // onClick={handleClearCart}
                onClick={handleClearCartClick}
                className={`h-6 w-6 cursor-pointer transition-transform transform ${
                  i18n.language == "ar" ? "scale-x-[-1]" : ""
                }`}
              />
            </div>
          </header>
          <main className="flex flex-col overflow-y-auto flex-1 custom-scrollbar mb-20">
            {localProducts?.map((product, index) => {
              return (
                <ProductCart
                  key={index}
                  ref={(el) => (productRefs.current[index] = el)}
                  product={product}
                  onDelete={onRemoveProduct}
                  onUpdateQuantity={onUpdateQuantity}
                  onUpdateDiscount={onUpdateDiscount}
                  isSelected={userSelectedIndex === index}
                  isScannerActive={isScannerActive}
                  userSelectedIndex={userSelectedIndex}
                  addGroupProductModal={addGroupProductModal}
                  groupModal={groupModal}
                />
              );
            })}
          </main>
          {/* <img
          src={logo} // Replace with your watermark icon path
          alt="watermark"
          className="absolute left-32 top-80 justify-center items-center opacity-5" // Centered with reduced opacity
          style={{ width: "20%", height: "20%", zIndex: 1000 }} // Adjust size and z-index
        /> */}
        </div>
        <SessionFooter
          setModals={setModals}
          localProducts={localProducts}
          setSelectedIndex={setSelectedIndex}
          totalBillAmount={totalBillAmount}
        />
      </div>
    </>
  );
};
